import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from "@app/interfaces";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var JobSidebarService = /** @class */ (function (_super) {
    tslib_1.__extends(JobSidebarService, _super);
    function JobSidebarService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.refreshAssignedUsers = new BehaviorSubject(null);
        _this.refreshAssignedUsers$ = _this.refreshAssignedUsers.asObservable();
        _this.refreshJobDetailsSubject = new Subject();
        _this.refreshJobDetails$ = _this.refreshJobDetailsSubject.asObservable();
        _this.refreshJobFinanceSubject = new Subject();
        _this.refreshJobFinance$ = _this.refreshJobFinanceSubject.asObservable();
        _this.saveJobStages = function (data, jobId) {
            return this.http.post(this.getApiUrl("save_job_stages/" + jobId), JSON.stringify(data));
        };
        _this.saveJobTeam = function (data, jobId) {
            return this.http.post(this.getApiUrl("save_job_team/" + jobId), JSON.stringify(data));
        };
        _this.saveJobTeamUsers = function (data, jobId) {
            return this.http.post(this.getApiUrl("save_job_team_users/" + jobId), JSON.stringify(data));
        };
        _this.saveTeamMembersList = function (teamId) {
            return this.http.post(this.getApiUrl("get_team_members/" + teamId));
        };
        return _this;
    }
    JobSidebarService.prototype.getJobDetails = function (type, id, jobId) {
        return this.http.get(this.getJobApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/details/view"));
    };
    JobSidebarService.prototype.getJobFinancialPerformance = function (type, id, jobId) {
        return this.http.get(this.getJobApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/financial-performance/view"));
    };
    JobSidebarService.prototype.getAssets = function (propertyId, jobId, screenType) {
        return this.http.get(this.getJobApiUrl("job_assets?propertyId=" + propertyId + "&jobId=" + jobId + "&screenType=" + screenType));
    };
    JobSidebarService.prototype.getCustomerJobAssets = function (type, id, jobAssetIds, jobId, data) {
        var params = {
            page: data.reqParams.page.toString(),
            limit: data.reqParams.limit.toString(),
            searchText: data.reqParams.searchText,
            sort: data.reqParams.sort || '',
            filters: data.reqParams.filters,
            jobId: jobId
        };
        return this.http.get(this.getJobApiUrl("customers/" + type + "/" + id + "/assets/list"), { params: params });
    };
    JobSidebarService.prototype.getAssetsColumns = function (propertyId, screenType) {
        return this.http.get(this.getApiUrl("customers/" + screenType + "/" + propertyId + "/assets/views"));
    };
    JobSidebarService.prototype.removeAssetFromJob = function (jobAssetId, jobId) {
        return this.http.get(this.getJobApiUrl("remove_job_asset/" + jobAssetId + "/job/" + jobId));
    };
    JobSidebarService.prototype.setAssignedUsers = function (data) {
        this.refreshAssignedUsers.next(data);
    };
    /** Notify sidebar to refresh job details (e.g. after cost summary update). Pass jobId to refresh only that job's sidebar. */
    JobSidebarService.prototype.notifyJobDetailsRefresh = function (jobId) {
        this.refreshJobDetailsSubject.next(jobId != null ? jobId : undefined);
    };
    JobSidebarService.prototype.notifyJobFinanceRefresh = function (jobId) {
        this.refreshJobFinanceSubject.next(jobId != null ? jobId : undefined);
    };
    JobSidebarService.prototype.retrieveAppliedUsers = function (jobId) {
        return this.http.get(this.getJobApiUrl("saved_users/" + jobId));
    };
    JobSidebarService.prototype.getDiaryFeedbackById = function (opportunityId, screenType) {
        return this.http.get(this.getApiUrl("get_diary_event_feedback_by_id/" + opportunityId + "/" + screenType));
    };
    JobSidebarService.ngInjectableDef = i0.defineInjectable({ factory: function JobSidebarService_Factory() { return new JobSidebarService(i0.inject(i1.HttpClient)); }, token: JobSidebarService, providedIn: "root" });
    return JobSidebarService;
}(InterfaceService));
export { JobSidebarService };
